<template>
  <div class="free-time-box">
    <p class="free-box" :style="styles">
      <img src="@/assets/img/count-down.svg" width="13">
      <span>{{$t('限时免费')}}</span>
    </p>
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'FreeTime',
  props:{
    styles:{
      type:Object,
      default:()=>({
        bottom:'32px'
      })
    }
  },
  data() {
    return {

    };
  },
  mounted() {

  },
  methods: {

  },
};
</script>
<style lang="scss" scoped>
  .free-time-box{
    display: inline-block;
    position: relative;
    line-height: unset;
    .free-box{
      position: absolute;
      width: 122px;
      height: 22px;
      display: flex;
      align-items: center;
      img{
        margin: 0 4px 0 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/freeTime/index.vue